import { select } from '../shared/utils/dom';

export default function manageAccount() {
  const elManageAccount = select('[data-vue-app="manage-account"]');
  if (elManageAccount) {
    new Vue({ // eslint-disable-line no-unused-vars
      el: elManageAccount,
      /**
       * Methods
       */
      methods: {
        redirectToURL(e) {
          if (e) {
            e.preventDefault();
          }
          const manageAccountColumn = e.srcElement.closest(".manage-account-column");
          const linkUrl = manageAccountColumn.dataset["linkUrl"];
          window.location.href = linkUrl;
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/manageAccount.js